module.exports = __webpack_public_path__ + "img/Ellipse2.6f4dbf10.png";